import { Provider } from '@angular/core';
import { TeamEventBus } from '@web-portal/domains/shared/event-bus';

export function provideTeamDomain(): Provider[] {
  return [TeamEventBus];
}
